import { render, staticRenderFns } from "./MessageTemplateBox.vue?vue&type=template&id=2f0c28e6&"
import script from "./MessageTemplateBox.vue?vue&type=script&lang=ts&"
export * from "./MessageTemplateBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports